<template>
  <div class="wrapper">
    <div class="module-list">
      <div v-for="(item,index) in moduleList" class="module-box" @click="changIndex(index)">
        <div class="module-wrapper" :class="curIndex == index?'active':''">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'index',
    data () {
      return {
        moduleList:[],
        curIndex:0,
      }
    },
    methods:{
      //获取假token
      getToken () {
        this.$get(this.urlobj.getMockToken,{
          account:'wangqing'
        }).then(res => {
          localStorage.token = res.newPrimaryKeys.token
          this.$store.commit("updateToken", res.newPrimaryKeys.token);
          this.getModule()
        })
      },
      // 获取首页配置模块
      getModule () {
        var url = this.urlobj.getModule+'?typeName=dsdp'
        this.$get(url).then(res => {
          this.moduleList = res.filter(item => item.isshow=='是').map(item => {
            return {
              name:item.name,
              url:item.domain,
            }
          })
        })
      },
      changIndex (index) {
        this.curIndex = index
        this.handleUrl()
      },
      // 重定向
      handleUrl () {
        var url = this.moduleList[this.curIndex].url
        if (!url) return
        window.open(url,'_self')
      },
      changeCard (type) {
        var totalIndex = this.moduleList.length - 1
        if (type == 'right') {
          //向右挪
          //如果当前已经是最后一个   下一个是0
          if (this.curIndex == totalIndex) this.curIndex = 0
          else this.curIndex ++
        }else if (type == 'left') {
          //想左挪
          //如果当前已经是第一个 下一个是最后一个
          if (this.curIndex == 0) this.curIndex = totalIndex
          else this.curIndex --
        }else if (type == 'up') {
          //向上挪
          //如果是第一行  不能再向上
          if (this.curIndex > 3) {
            this.curIndex = this.curIndex-4
          }
        }else if (type =='down') {
          //向下挪
          //如果是最后一行  不能再向下
          if (this.curIndex <= totalIndex - 4) {
            this.curIndex = this.curIndex + 4
          }
        }else if (type == 'confirm') {
          this.handleUrl()
        }else if (type == 'reload') {
          location.reload()
        }
      }
    },
    mounted () {
      this.getToken()
      window.btnclick = this.changeCard
      document.getElementsByTagName('body')[0].style.zoom=0.5
    }
  }
</script>

<style scoped>
.wrapper{
  height: 100%;
  display: flex;
  align-items: center;
  background: url("../../assets/images/tvBackground.jpg");
  background-size: 100% 100%;
}
.module-list{
  display: flex;
  flex-wrap: wrap;
  padding-right: 5.2%;
  width: 100%;
  color:#fff;
  margin-top: 5.2%;
}
  .module-box{
    width: 25%;
    padding-left: 5.2%;
    margin-bottom: 5.2%;
  }
  .module-wrapper{
    height: 155px;
    background: #1c478b;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    font-weight: 600;
    border-radius: 7px;
    padding: 0 20px;
  }
  .active{
    border: 5px solid #00d1ff;
    box-shadow: 0px 0px 15px 5px #0469ad;
    background: transparent;
  }
</style>
